export default "__VITE_ASSET__CLy6h3wt__"